export function SkippedPageBanner() {
  return (
    <div role="note" className="rounded-md border bg-muted px-3 py-2 text-sm text-muted-foreground">
      Skipped: the summary did not read this page.
    </div>
  );
}
